import { errorMessage } from "actions/message";
import { post } from "utils/api";

export const Types = {
  GET_AI_JOBS_RESPONSE: "GET_AI_JOBS_RESPONSE",
  START_AI_JOB_RESPONSE: "START_AI_JOB_RESPONSE",
  KILL_AI_JOB_RESPONSE: "KILL_AI_JOB_RESPONSE"
};

export const fetchAICallJobs = (startDate, endDate) => async dispatch => {
  try {
    const response = await post(`synthpop/ai_thread_index`, {
      startDate,
      endDate
    });
    dispatch({ type: Types.GET_AI_JOBS_RESPONSE, response });
    return [];
  } catch (error) {
    dispatch(errorMessage("Failed to get list of AI jobs"));
  }
};
